import { Button, Select, TextInput, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { HiPlus } from 'react-icons/hi';
import { useAppSelector } from '../../../Reducers/store';
import Loader from '../../Common/Loader';
import DeliveryListTable from './DeliveryListTable';
import { Delivery } from '../../../Models/Delivery';
import DeliveryApi from '../../../Api/DeliveryApi';
import DeliveryModal from './DeliveryModal';
import ViewReportModal from '../../Common/ViewReportModal';
import { BasicSearchRequest } from '../../../Models/BasicSearchRequest';
import { formatDateInputs } from '../../../Utils';

export default function DeliveryList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [deliveryListData, setdeliveryListData] = useState<Delivery[]>([]);
  const [selectedDelivery, setselectedDelivery] = useState<Delivery | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showdropTicketModal, setshowdropTicketModal] =
    useState<boolean>(false);
  const [pdfURL, setPDFURL] = useState<string>('');
  const [pdfBlob, setpdfBlob] = useState<Blob | null>(null);
  const [fileName, setfileName] = useState<string>('');
  const [formData, setFormData] = useState<BasicSearchRequest>({
    status: 2,
    fromDate: new Date(new Date().setDate(new Date().getDate() - 14))
      .toISOString()
      .split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getDeliveries = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return DeliveryApi.getDeliveryList(formData)
          .then((res) => {
            setdeliveryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            console.error(err);
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getDeliveries();
  }, []);

  const handleAddDeliveryClick = () => {
    setselectedDelivery(null);
    setShowModal(true);
  };

  const editDelivery = (d: Delivery) => {
    setselectedDelivery(d);
    setShowModal(true);
  };

  function deleteDelivery(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      DeliveryApi.deleteDelivery(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getDeliveries();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  const sendToQuickbooks = async (d: Delivery) => {
    setIsLoading(true);
    return await DeliveryApi.sendToQuickbooks(d)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          getDeliveries();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
      });
  };

  const viewDropTicket = async (d: Delivery) => {
    setIsLoading(true);
    return await DeliveryApi.getDropTicketReport(d.id)
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        setpdfBlob(pdfBlob);
        setPDFURL(url);
        setfileName(
          d.client?.name ? d.client?.name + '_Drop Ticket' : 'Drop Ticket'
        );
        setshowdropTicketModal(true);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
      });
  };

  const viewInvoice = async (d: Delivery) => {
    setIsLoading(true);
    return await DeliveryApi.getInvoiceReport(d.id)
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        setPDFURL(url);
        setfileName(d.client?.name ? d.client?.name + '_Invoice' : 'Invoice');
        setshowdropTicketModal(true);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
      });
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    getDeliveries();
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Deliveries</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Button onClick={handleAddDeliveryClick} className='buttonMain'>
                  <HiPlus size={20} />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className='flex pl-4 mx-1'>
          <div className=''>
            <form
              id='searchForm'
              onSubmit={onSubmit}
              className='flex gap-4 justify-center'
            >
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>Status:</div>
                <Select
                  id='status'
                  name='status'
                  onChange={handleChangeSelect}
                  value={formData.status ?? ''}
                  sizing='md'
                  required
                >
                  <option key={0} value={0}>
                    All
                  </option>
                  <option key={1} value={1}>
                    In Process
                  </option>
                  <option key={2} value={2}>
                    Submitted
                  </option>
                  <option key={3} value={3}>
                    Approved
                  </option>
                  <option key={4} value={4}>
                    Invoiced
                  </option>
                  <option key={5} value={5}>
                    Canceled
                  </option>
                </Select>
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>From:</div>
                <TextInput
                  id='fromDate'
                  name='fromDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.fromDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <div className='flex gap-1'>
                <div className='content-center text-xl font-bold'>To:</div>
                <TextInput
                  id='toDate'
                  name='toDate'
                  type='date'
                  placeholder='Date...'
                  onChange={handleChange}
                  value={formatDateInputs(formData.toDate ?? '')}
                  sizing='md'
                  pattern='\d{4}-\d{2}-\d{2}'
                  required
                />
              </div>
              <Button
                type='submit'
                form='searchForm'
                className='buttonMain'
                // disabled={buttonDisabled}
              >
                Search
              </Button>
            </form>
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <DeliveryListTable
              data={deliveryListData}
              deleteDelivery={deleteDelivery}
              editDelivery={editDelivery}
              sendToQuickbooks={sendToQuickbooks}
              viewDropTicket={viewDropTicket}
              viewInvoice={viewInvoice}
            />
          </div>
        </div>
      </div>
      <DeliveryModal
        show={showModal}
        setShow={setShowModal}
        getDeliveries={getDeliveries}
        selectedDelivery={selectedDelivery}
        setselectedDelivery={setselectedDelivery}
      />
      <ViewReportModal
        show={showdropTicketModal}
        setShow={setshowdropTicketModal}
        url={pdfURL}
        fileName={fileName}
        blob={pdfBlob}
      />
    </>
  );
}
